import RequesterV1 from "@/components/api/v1/requester.js";

export default {

  fetchAgroExporterProcess(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/process/show_reports/${producer_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchSummary(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/process/show_reports/${producer_id}/fetch_summary/${agro_exporter_process_id}`
    );
  },

  fetchDiscardedMotives(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/process/show_reports/${producer_id}/fetch_discarded_motives/${agro_exporter_process_id}`
    );
  },

  fetchHarvestsMonthly(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/process/show_reports/${producer_id}/fetch_harvests_monthly/${agro_exporter_process_id}`
    );
  },

  fetchHarvestsWeekly(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/process/show_reports/${producer_id}/fetch_harvests_weekly/${agro_exporter_process_id}`
    );
  },

  fetchTotalsMonthly(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/process/show_reports/${producer_id}/fetch_totals_monthly/${agro_exporter_process_id}`
    );
  },

  fetchTotalsWeekly(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/process/show_reports/${producer_id}/fetch_totals_weekly/${agro_exporter_process_id}`
    );
  },

  fetchCropSizes(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/process/show_reports/${producer_id}/fetch_crop_sizes/${agro_exporter_process_id}`
    );
  },

  fetchCropSizePackages(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/process/show_reports/${producer_id}/fetch_crop_size_packages/${agro_exporter_process_id}`
    );
  },

  fetchCropSizePackagesByWeeks(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/process/show_reports/${producer_id}/fetch_crop_size_packages_by_weeks/${agro_exporter_process_id}`
    );
  },

  fetchHarvestedBatches(producer_id, agro_exporter_process_id, current_page, rows_per_page) {
    return RequesterV1.get(
      `producer/reporting/process/show_reports/${producer_id}/fetch_harvested_batches/${agro_exporter_process_id}/${current_page}/${rows_per_page}`
    );
  },

  fetchHarvestedBatchesTotal(producer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `producer/reporting/process/show_reports/${producer_id}/fetch_harvested_batches_total/${agro_exporter_process_id}`
    );
  },

  fetchHarvestedBatch(producer_id, agro_exporter_process_id, harvested_batch_id) {
    return RequesterV1.get(
      `producer/reporting/process/show_reports/${producer_id}/fetch_harvested_batch/${agro_exporter_process_id}/${harvested_batch_id}`
    );
  }
}
